/* eslint-disable no-continue */
import {
  IDisplayTicket,
  IDisplayTicketItem,
} from '../interfaces/IDisplayTicket';

export function resetSubItemsOnItems(
  tickets: IDisplayTicket[]
): IDisplayTicket[] {
  const formatted: IDisplayTicket[] = [];
  for (const ticket of tickets) {
    const formattedItems: IDisplayTicketItem[] = [];
    for (const item of ticket.items) {
      const { id: itemId, comboItemOf } = item;

      if (comboItemOf) {
        const existsOnCurrentItemList = ticket.items.find(
          (parent) => parent.id === comboItemOf
        );
        if (!existsOnCurrentItemList) {
          formattedItems.push(item);
        }

        continue;
      }

      const subitems =
        ticket.items.filter((_item) => _item.comboItemOf === itemId) || [];
      formattedItems.push({
        ...item,
        subitems,
      });
    }

    formatted.push({
      ...ticket,
      items: formattedItems,
    });
  }

  return formatted;
}
